import { cn } from "@/lib/utils";
import type { DataTableFeatures } from "@/types/dataTableSettings";

const CLASS_NAME_DELETED = "bg-red-50/70";

export function getRowPropsWithDeletedHighlight<T>(
  isDeleted: (row: T) => boolean,
  baseGetRowProps?: DataTableFeatures["getRowProps"],
): NonNullable<DataTableFeatures["getRowProps"]> {
  return (row) => {
    const base = baseGetRowProps?.(row) ?? {};
    return {
      ...base,
      className: cn(base.className as string, {
        [CLASS_NAME_DELETED]: isDeleted(row.original as unknown as T),
      }),
    };
  };
}
